/* unplugin-vue-components disabled */import script from "./BasePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePassword.vue?vue&type=script&setup=true&lang=js"

import "./BasePassword.vue?vue&type=style&index=0&id=33676792&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33676792"]])

export default __exports__